import React from "react";
import { Box } from '@mui/material';
import FlightCard from "./FlightCard";


const FlightList = ({ flights = [], onClick }) => {    

    return (
        <Box 
            display="flex" 
            flexDirection="column" 
            gap={2}
        >
            {flights?.map((f, idx) => (
                <FlightCard
                    key={f._id}
                    index={idx}
                    flight={f}
                    onClick={onClick}
                />
            ))}
        </Box>
    );
};

export default FlightList;
